import {ModelSetOptions} from 'backbone';

import {Model as SequencePrimer} from 'biojs/SequencePrimer';

export interface AminoAcid {
  b: string;
  backgroundColor: string;
  glyphColor: string;
  aaIndex: number;
  indexStart: number;
  indexEnd: number;
}

// Results from primer3 tool, parsed by our backend, transformed by the client to swap out the
// primer info from primer3 with our own SequencePrimer references.
// Some documentation is at http://primer3.org/manual.html
export interface Primer3Match {
  compl_any_th: number;
  compl_end_th: number;
  forward: SequencePrimer;
  penalty: number;
  probe?: SequencePrimer;
  product_size: number;
  reverse: SequencePrimer;
  // UI state tacked onto the model.
  saved?: boolean;
  forwardSelected?: boolean;
  probeSelected?: boolean;
  reverseSelected?: boolean;
}

export interface Primer3MatchModel extends Backbone.Model {
  get<K extends keyof Primer3Match>(key: K): Primer3Match[K];
  set(values: Partial<Primer3Match>, options?: ModelSetOptions): this;
  set<K extends keyof Primer3Match>(
    key: K,
    value: Primer3Match[K],
    options?: ModelSetOptions
  ): Primer3Match[K];
}

export type Primer3Direction = 'forward' | 'reverse' | 'probe';
export const PRIMER3_DIRECTIONS: Array<Primer3Direction> = ['forward', 'reverse', 'probe'];

export enum DNA_SEQUENCE_IMPORT_FLOW {
  FILE = 'file_import',
  DB = 'db_import',
  CHROMOSOME = 'chromosome_import',
  RAW = 'raw_import',
}

export enum OLIGO_CREATION_METHODS {
  MODAL = 'modal_import',
  SPREADSHEET = 'spreadsheet_import',
}

export enum AA_SEQUENCE_IMPORT_MODAL_TAB {
  CREATE = 'create',
  FILE = 'file_import',
  DB = 'db_import',
}

export enum BIOENTITY_CREATION_LOCATIONS {
  // Old analytics creation location strings - maintained for compatibility with existing dashboards
  GLOBAL = 'global',
  PROJECT = 'project',
  // New analytics creation location strings
  GLOBAL_CREATE_BUTTON = 'global_create_button',
  PROJECT_SIDEBAR_CREATE_BUTTON = 'project_sidebar_create_button',
}

// Sequence ID of temporary or preview sequences that aren't saved entities,
// such as in alignments or bulk assembly previews
export const TEMP_SEQUENCE_ID = 'tempid';
